module.exports = __webpack_public_path__ + "img/cb-f-n-rr1.57972010.gif";